import React, { useEffect, useState, useCallback } from 'react';
import {
  Alert, AlertIcon, Badge, Box, Heading, Icon, Spinner, Table, Tbody,
  Td, Text, Th, Thead, Tr,
} from '@chakra-ui/react';
import { FiBook } from 'react-icons/fi';

const ACTION_COLORS = {
  create: 'green',
  update: 'blue',
  delete: 'red',
  sso_login: 'teal',
  sso_provision: 'purple',
};

export default function AuditLog({ token, apiBase }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(() => {
    fetch(`${apiBase}/api/audit-logs/`, {
      headers: { Authorization: `Token ${token}` },
    })
      .then(r => r.json())
      .then(data => setLogs(data.results || []))
      .catch(() => setError('Failed to load audit logs'))
      .finally(() => setLoading(false));
  }, [apiBase, token]);

  useEffect(() => { load(); }, [load]);

  return (
    <Box p={8}>
      <Heading size="lg" color="gray.800" mb={2}>Audit Log</Heading>
      <Text color="gray.500" mb={6}>Recent admin and SSO activity</Text>

      {error && <Alert status="error" mb={4}><AlertIcon />{error}</Alert>}
      {loading && <Spinner size="xl" color="blue.500" />}

      {!loading && logs.length === 0 && (
        <Box textAlign="center" py={20} color="gray.400">
          <Icon as={FiBook} boxSize={12} mb={4} />
          <Text>No audit entries yet.</Text>
        </Box>
      )}

      {!loading && logs.length > 0 && (
        <Box bg="white" rounded="xl" shadow="sm" overflow="hidden">
          <Table variant="simple" size="sm">
            <Thead bg="gray.50">
              <Tr>
                <Th>Time</Th>
                <Th>User</Th>
                <Th>Action</Th>
                <Th>Type</Th>
                <Th>Object</Th>
                <Th>Tenant</Th>
                <Th>IP</Th>
              </Tr>
            </Thead>
            <Tbody>
              {logs.map(log => (
                <Tr key={log.id} _hover={{ bg: 'gray.50' }}>
                  <Td fontSize="xs" color="gray.500" whiteSpace="nowrap">
                    {new Date(log.created_at).toLocaleString()}
                  </Td>
                  <Td fontSize="sm">{log.username || '—'}</Td>
                  <Td>
                    <Badge colorScheme={ACTION_COLORS[log.action] || 'gray'} fontSize="xs">
                      {log.action}
                    </Badge>
                  </Td>
                  <Td fontSize="sm" color="gray.600">{log.model_type}</Td>
                  <Td fontSize="sm">{log.object_name || log.object_id || '—'}</Td>
                  <Td fontSize="sm" color="blue.600">{log.tenant_id || '—'}</Td>
                  <Td fontSize="xs" color="gray.400">{log.ip_address || '—'}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      )}
    </Box>
  );
}
